import { Link } from "react-router-dom";
import { hotRankings } from "@/mocks/comics";

export default function RankingSidebar() {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200/70 p-5">
      <div className="flex items-center gap-2 mb-4">
        <i className="ri-fire-line text-accent-500 text-lg"></i>
        <h3 className="text-base font-semibold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
          热度排行榜
        </h3>
      </div>

      <div className="flex flex-col gap-0">
        {hotRankings.map((item) => (
          <Link
            key={item.rank}
            to={`/article/${item.slug}`}
            className="flex items-center gap-3 py-2.5 border-b border-background-100 last:border-b-0 hover:bg-background-50/80 transition-colors cursor-pointer group"
          >
            <span
              className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-500"
              }`}
            >
              {item.rank}
            </span>
            <span className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1 flex-1">
              {item.title}
            </span>
            <span className="flex-shrink-0">
              {item.trend === "up" && <i className="ri-arrow-up-line text-green-500 text-xs"></i>}
              {item.trend === "down" && <i className="ri-arrow-down-line text-red-500 text-xs"></i>}
              {item.trend === "new" && (
                <span className="text-[10px] text-accent-500 font-medium">NEW</span>
              )}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}